import type { NavigateFunction } from 'react-router-dom';
import { toast } from 'react-toastify';
import { createSessionCallAccessState } from '@/constants/sessionCall';
import { resolveVideoRoomApiError } from '@/components/session-call/sessionCallDailyJoin';
import { SessionService } from '@/services';

type OpenUserSessionCallOptions = {
	sessionId: string;
	navigate: NavigateFunction;
	sessionStatus?: Sessions.SessionStatus;
	onStart?: () => void;
	onFinally?: () => void;
};

export async function openUserSessionCall({
	sessionId,
	navigate,
	sessionStatus,
	onStart,
	onFinally,
}: OpenUserSessionCallOptions): Promise<void> {
	onStart?.();
	const loadingToastId = toast.info('Buscando reunião...', {
		autoClose: false,
		closeButton: false,
	});

	try {
		const credentials = await SessionService.getVideoRoom(sessionId);
		toast.dismiss(loadingToastId);
		toast.info('Entrando na reunião...');
		navigate(`/sessao-chamada/${sessionId}`, {
			state: createSessionCallAccessState(
				'user',
				undefined,
				sessionStatus,
				credentials,
			),
		});
	} catch (error) {
		toast.dismiss(loadingToastId);
		const apiError = resolveVideoRoomApiError(error);
		toast.error(
			apiError?.message ??
				'Não foi possível buscar a reunião. Tente novamente.',
		);
	} finally {
		onFinally?.();
	}
}
